import { motion } from 'framer-motion';

// ATELIER — long-form essay with drop-cap on the studio in Florence.
export default function Atelier() {
  return (
    <div className="bg-[#F2E8D5] text-[#1F3A2E] min-h-screen">
      <section className="pt-32 pb-8 max-w-[1500px] mx-auto px-8 lg:px-14 border-b-[3px] border-[#1F3A2E]">
        <p className="font-mono text-[10px] tracking-[0.4em] uppercase text-[#7B5527] mb-3">— Section III / Atelier · pp. 97 — 102</p>
        <h1 className="font-serif italic text-[44px] lg:text-[88px] leading-[0.95]">A small workshop<br />on Calzaiuoli.</h1>
      </section>

      <section className="max-w-[1500px] mx-auto px-8 lg:px-14 py-12 grid lg:grid-cols-[1fr_1.4fr] gap-12 items-start">
        <motion.div initial={{ opacity: 0, x: -20 }} whileInView={{ opacity: 1, x: 0 }} viewport={{ once: true }} className="aspect-[3/4] overflow-hidden border-[3px] border-[#1F3A2E]/15 sticky top-28">
          <img src="https://images.pexels.com/photos/2887766/pexels-photo-2887766.jpeg?auto=compress&cs=tinysrgb&w=1200" alt="" className="w-full h-full object-cover" />
        </motion.div>
        <div className="font-serif text-base leading-[1.85] text-[#1F3A2E]/85 space-y-5">
          <p>
            <span className="float-left font-serif italic text-[100px] leading-[0.78] mr-2 mt-1 text-[#7B5527]">W</span>
            e moved into the rooms above the cobbler in 1992. The cobbler is still there, on the ground floor; he takes the bell and we take the staircase, three flights of unwaxed terracotta tile.
          </p>
          <p>The atelier is small. There are six of us most days, and a seventh on Thursdays — Anna's mother, who comes for the tea, and stays to hand-finish buttonholes because no one else will.</p>
          <p>We make eight collections a year and we print a catalogue for each. The catalogue is sent on the fourteenth of the month, by post, to fourteen hundred readers, a number that has not changed since 2003.</p>
          <p>If you would like to be the fourteen hundred and first, the address is the same as it has always been. <em>Via dei Calzaiuoli 17, primo piano.</em> Bring something on paper.</p>

          <div className="grid grid-cols-3 gap-6 pt-9 border-t border-[#1F3A2E]/20 mt-9 font-mono text-[10px] tracking-[0.32em] uppercase text-[#1F3A2E]/65">
            <div><p>Year founded</p><p className="font-serif normal-case tracking-normal text-3xl text-[#1F3A2E] mt-1">1992</p></div>
            <div><p>Collections / year</p><p className="font-serif normal-case tracking-normal text-3xl text-[#1F3A2E] mt-1">8</p></div>
            <div><p>Subscribed readers</p><p className="font-serif normal-case tracking-normal text-3xl text-[#7B5527] mt-1">1,400</p></div>
          </div>
        </div>
      </section>
    </div>
  );
}
